import * as React from 'react';

import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import {GoogleLogin, GoogleLogout} from 'react-google-login';

import { gapi } from 'gapi-script';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Box, Button, Alert } from '@mui/material';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const API_URL = `${process.env.REACT_APP_API_URL}`;

const clientIdGoogle = "568636538887-5vhfa5joq6r4lac047icdrv8fjio5ff3.apps.googleusercontent.com";

export default function LoginForm() {
  const [profile, setProfile] = useState(null);
  const navigate = useNavigate();


  const [showPassword, setShowPassword] = useState(false);
  const [showResponse, setResponse] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);

    const jsonData = {
      email: data.get('email'),
      password: data.get('password'),
    };

    fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(jsonData)
      })
      .then(response => response.json())
      .then(data => {
     
        if(data.status === 'ok'){
          
          // localStorage.setItem('token', data.results.token);
          // sessionStorage.setItem('token', data.results.token);
          sessionStorage.setItem('fname', data.results.fname);
          sessionStorage.setItem('lname', data.results.lname);
          sessionStorage.setItem('email', data.results.email);

          navigate('/send_otp');        
        }else if(data.status === 'error_disabled'){
          setResponse('อีเมลผู้ใช้นี้ถูกยกเลิกใช้งาน กรุณาติดต่อผู้ดูแลระบบ !');
        }else if(data.status === 'error_no_user'){
          setResponse('ไม่พบข้อมูลผู้ใช้งานนนี้ในระบบ !');
        }else if(data.status ==='error_login' ){
          setResponse('กรุณากรอกอีเมลและหัสผ่านให้ถูกต้อง !');
        }else{
          setResponse('เกิดข้อผิดพลาดของระบบ !');
        }
        
      })
      .catch(() =>{
        setResponse('Error Connect API !');
      });
  };

  const handleResetPass = async e => {
    e.preventDefault();
    navigate("/reset_pass");
  }

  const onSuccess = (res) => {
    setProfile(res.profileObj)
    console.log(res.profileObj)
    CheckEmailFromGoogle(res.profileObj)
    console.log("success",res)
  }

  const onFailure = (res) => {
    console.log("Failed",res)
  }

  const logOut = () => {
    setProfile(null);
  }

  React.useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: clientIdGoogle,
        scope:""
      })
    };
    gapi.load('client:auth2',start);
  });

  // var accessToken = gapi.auth.getToken().access_token;
  const CheckEmailFromGoogle = (Getdata) => {    
    const jsonData = {
      email: Getdata.email,
      fname: Getdata.familyName,
      lname: Getdata.givenName,
      status: 1,
      lastupdate: "2023-05-29 16:39:00"
    };

    fetch(`${API_URL}/register_google`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonData)
    })
    .then(response => response.json())
    .then(data => {
   
      if(data.status === 'ok'){

        fetch(`${API_URL}/loginnew`, {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify(jsonData)
        })
        .then(response => response.json())
        .then(data => {
          if(data.status === 'ok'){
            localStorage.setItem('token', data.results.token);
            navigate('/dashboard');        
          }else{
            console.log("พบข้อมผิดพลาดของระบบ")
          }
        })

      }else{
        console.log('เกิดข้อผิดพลาดของระบบ !');
      }
      
    })
    .catch(() =>{
      // setResponse('Error Connect API !');
      console.log("API Error");
    });    
  }
  

  return (
    <>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
      <Stack spacing={3}>
          {showResponse &&<Alert severity="error" ><strong>{showResponse}</strong> </Alert>}
          <TextField  id="outlined-error-helper-text" name="email" label="Email address" />
          <TextField
            name="password"
            label="Password"
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
      
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2,textAlign: 'right' }}>
      
        <Link variant="subtitle2" underline="hover" sx={{cursor: 'pointer'}} onClick={handleResetPass}>
          Forgot Password?
        </Link>
      </Stack>
      <Button type="submit" fullWidth variant="outlined" sx={{ mt: 2, mb: 2 }}>
              Sign In
      </Button>
      {profile ?(
        <div>
          <GoogleLogout clientId={clientIdGoogle} buttonText="Log out" onLogoutSuccess={logOut} />
        </div>
      ) : (
        <GoogleLogin
      clientId={clientIdGoogle}
      buttonText="Login with Google"
      onSuccess={onSuccess}
      onFailure={onFailure}
      cookiePolicy={'single_host_origin'}      
      />
      )}      
      </Box>
      
    </>
  );
}
